"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/SimpleSelect.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



















const SimpleSelect = ({
  value,
  onChange,
  options,
  id,
  className,
  disabled,
  isRequired,
  describedBy,
  'aria-label': ariaLabel,
}) => {
  const handleChange = _react.useCallback.call(void 0, 
    // SAFETY: the <option>s below are rendered only from `options`, so the value is a T.
    (e) => onChange(e.target.value ),
    [onChange],
  )

  return (
    _react2.default.createElement('select', {
      id: id,
      value: value,
      disabled: disabled,
      'aria-required': isRequired || undefined,
      'aria-describedby': describedBy,
      'aria-label': ariaLabel,
      onChange: handleChange,
      className: _classBuilder2.default.call(void 0, 
        'blm-simple-select',
        !value && 'blm-simple-select--placeholder',
        className,
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}

      ,  options
        .map(o => (
          _react2.default.createElement('option', {
            key: o.value,
            value: o.value,
            hidden: !o.value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}

            ,  o.label 
          )
        ))
      
    )
  )
}

exports. default = SimpleSelect
